import { Fragment } from 'react';
import { TankCreate } from 'app/agriculture/routes/Tanks/TankCreate/TankCreate';
import { TankDelete } from 'app/agriculture/routes/Tanks/TankDelete/TankDelete';
import { TankDetails } from 'app/agriculture/routes/Tanks/TankDetails/TankDetails';
import { TankEdit } from 'app/agriculture/routes/Tanks/TankEdit/TankEdit';
import { RouteConfig } from 'app/agriculture/router/types';
import { TankDetailsSkeleton } from 'app/agriculture/routes/Tanks/TankDetails/components/TankDetailsSkeleton';

export const tanksRouteConfig: RouteConfig = {
    rootPath: 'tanks',
    routeElements: {
        Create: { Component: TankCreate },
        Delete: { Component: TankDelete },
        Details: { Component: TankDetails, Skeleton: TankDetailsSkeleton },
        Edit: { Component: TankEdit },
        List: { Component: Fragment },
    },
};
